import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Avatar from "../images/avatar.png";
import Notifications from './Notifications';
import { Link } from 'react-router-dom';
import { getPrivateConversationsAction } from '../../redux/actions/chatActions';
import ThemeSwitcher from '../theme/ThemeSwitcher';

const TopBar = ({ isExpanded, hoverExpand, handleClick, user, setExpandHeader }) => {
    const dispatch = useDispatch();
    const { conversations } = useSelector(state => state.conversations);

    useEffect(() => {
        dispatch(getPrivateConversationsAction({ perPage: 100 }));
    }, [dispatch]);

    const unreadMessagesCount = conversations?.filter(c => !c.is_last_message_seen && c.last_message?.message_sender !== "me").length || 0;

    return (
        <div
            className={`${isExpanded ? "w-[100%] lg:w-[82%]" : "w-[100%] lg:w-[95%]"} fixed top-0 right-0 transition-all duration-300 z-[40] pt-4 px-4 lg:px-6 pointer-events-none`}>
            <div className="bg-white/80 dark:bg-slate-900/80 backdrop-blur-md shadow-sm border border-slate-100 dark:border-slate-700 flex justify-between items-center rounded-2xl px-4 lg:px-6 py-3 pointer-events-auto font-jakarta">
                <button
                    className="flex-center w-10 h-10 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-500 dark:text-slate-300 hover:text-blue-600 dark:hover:text-sky-400 transition-colors duration-200"
                    onClick={() => setExpandHeader((prev) => !prev)}
                >
                    <i className="fa-solid fa-bars-staggered text-xl"></i>
                </button>

                <div className="flex min-w-0 items-center gap-2 sm:gap-3 lg:gap-6 relative">
                    <ThemeSwitcher />

                    <Notifications />

                    <Link to="/messenger" className="relative flex items-center justify-center w-10 h-10 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors" title="Open Chat">
                        <i className="fa-regular fa-comment-dots text-xl text-[#5a6a85] dark:text-slate-300"></i>
                        {unreadMessagesCount > 0 && (
                            <span className="absolute top-1 right-1 w-4 h-4 rounded-full bg-red-500 text-[10px] text-white shadow-sm flex items-center justify-center">
                                {unreadMessagesCount > 99 ? "99+" : unreadMessagesCount}
                            </span>
                        )}
                    </Link>

                    <span className="hidden sm:inline text-slate-300 dark:text-slate-600 font-light text-xl">|</span>
                    <div className="flex min-w-0 items-center gap-3 cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-800 p-1 sm:p-2 rounded-xl transition-colors">
                        <div className="w-10 h-10 rounded-full overflow-hidden shadow-sm">
                            <img
                                src={user?.avatar_url || Avatar}
                                alt=""
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <div className="hidden sm:flex min-w-0 flex-col">
                            <h3 className="max-w-[140px] truncate text-sm font-semibold text-[#2a3547] dark:text-slate-100">
                                {user?.name}
                            </h3>
                            <span className="text-xs text-[#5a6a85] dark:text-slate-400 font-medium">
                                {user?.role === "SUPER_ADMIN" ? "Super Admin" : user?.role === "ADMIN" ? "Admin" : user?.role === "PMM" ? 'Seller' : "PM"}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TopBar
